export default "__VITE_ASSET__4040a02b__"